export enum ItemCategoryType {
  Folder = 'folder',
  Single = 'single',
}
